
import React, { Fragment } from 'react';
import PageTitle from '../../components/pagetitle/PageTitle';
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import Advertisingagent from '../../components/AdvertisingAgent/AdvertisingAgent';


const AdvertisingAgent = (props) => {

    return (
        <Fragment>
            <div className='index_ico page_wrapper'>
                <Header />
                <main className="page_content">
                    <PageTitle pageTitle={'TopCoin UK Agents'} pagesub={'Home'} />
                    <Advertisingagent />
                </main>
                <Footer />
                <Scrollbar />
            </div>
        </Fragment>
    );
};
export default AdvertisingAgent;